import React from 'react';
import ExperienceCard from '../ExperienceCard/ExperienceCard';
import './Experience.scss';

const Experience = () => {
	const experience = [
		{
			title: 'Senior Software Engineer',
			company: 'NewsBank',
			period: 'December 2021 — December 2024',
			logoUrl: 'https://jbout.in/images/newsbank.png',
			highlights: [
				'Architected and deployed NewsBank’s first modern React/Redux application, establishing the scalable foundation and front-end standards utilized across multiple teams.',
				'Developed reusable, high-quality UI components using React and TypeScript, ensuring intuitive, accessible (A11Y) workflows through collaboration with product and end-users.',
				'Championed and executed an organization-wide WCAG 2.2 accessibility initiative, encompassing developer training, real-user testing with assistive technologies, and mentoring product staff to achieve full compliance.',
				'Streamlined the release process by integrating automated deployment strategies and CI/CD pipelines in GitLab, resulting in accelerated delivery and a quantifiable reduction in errors.',
				'Translated user research and business goals into actionable UX/UI improvements, collaborating closely with product managers in Agile ceremonies (e.g. sprint planning) to prioritize features and deliver high-quality solutions on time.',
			],
		},
		{
			title: 'Senior Frontend Developer',
			company: 'EBSCO Information Services',
			period: 'June 2016 — February 2020',
			logoUrl: 'https://jbout.in/images/ebsco.png',
			highlights: [
				'Championed WCAG 2.1 accessibility best practices by integrating inclusive design throughout the development lifecycle, leading organization-wide initiatives that included mentoring developers, conducting audits, and driving continuous improvement.',
				"Developed the high-traffic frontend for EBSCOhost's academic search engine and a DRM-protected eBook/audiobook viewer as a microservice, leveraging React and Redux for intuitive state management.",
				'Delivered accessible, responsive UIs using modern JavaScript/TypeScript patterns, validated through rigorous usability testing to ensure maximum user satisfaction.',
				'Served as UX Lead for a 7-person cross-functional team, prototyping and testing innovative UI/UX concepts for the eBook Reader using Balsamiq and Figma to enhance key feature discoverability.',
				'Conducted user interviews and usability testing to validate prototypes, uncover pain points, and prioritize high-impact enhancements; collaborated with backend teams on root-cause analysis of production issues to inform iterative product improvements.',
				'Identified and resolved performance bottlenecks using profiling tools, implementing targeted front-end and back-end optimizations to significantly improve application speed, responsiveness, and overall user experience.',
			],
		},
		{
			title: 'UX Engineer',
			company: 'DataGravity (Contracted by Makibie)',
			period: 'June 2013 — March 2016',
			logoUrl: 'https://jbout.in/images/datagravity.png',
			highlights: [
				'Collaborated extensively with Product, QA, and Engineering teams to define user needs, subsequently designing and prototyping intuitive user interfaces that directly resolved key user pain points and met critical business goals.',
				"Architected and developed reusable UI components and interaction patterns for a comprehensive design system, ensuring brand and UX consistency across the company's product suite.",
			],
		},
		{
			title: 'Frontend Developer',
			company: 'Right Networks',
			period: 'April 2010 — May 2013',
			logoUrl: 'https://jbout.in/images/right%20networks.png',
			highlights: [
				'Developed the responsive and user-friendly corporate website using C#, HTML, CSS, and JavaScript, optimizing performance by implementing efficient coding practices and significantly minimizing page load times.',
				'Collaborated directly with the Sales and Marketing teams to create and manage campaigns that successfully boosted sales conversions and expanded customer outreach.',
			],
		},
		{
			title: 'Web Developer',
			company: 'Rockdown.net',
			period: 'July 2006 — Ongoing',
			logoUrl: 'https://jbout.in/images/rockdown.png',
			highlights: [
				'Collaborated with local musicians and small businesses to create websites that aligned with their brand.',
				'Worked with internal design and development teams to enhance websites, ensuring scalability and accessibility.',
			],
		},
	];

	return (
		<div className="experience">
			<h2 className="experience__title">Professional Experience</h2>
			<div className="experience__list">
				{experience.map((job, index) => (
					<ExperienceCard key={index} job={job} />
				))}
			</div>
		</div>
	);
};

export default Experience;
